import { render, staticRenderFns } from "./MyRequestStoreFree.vue?vue&type=template&id=06e634fe&scoped=true&"
import script from "./MyRequestStoreFree.vue?vue&type=script&lang=js&"
export * from "./MyRequestStoreFree.vue?vue&type=script&lang=js&"
import style0 from "./MyRequestStoreFree.vue?vue&type=style&index=0&id=06e634fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e634fe",
  null
  
)

export default component.exports